module.exports = __webpack_public_path__ + "img/m_info2024.cf8ffc7c.png";